import React from 'react'
import styles from './RichTextDisplay.module.scss'

export const RichTextDisplay = ({
  contentHtml,
  style,
  as,
  className,
}: {
  contentHtml: string
  style?: React.CSSProperties
  as?: React.ElementType
  className?: string
}) => {
  const Component = as ?? 'div'

  return <Component style={style} className={className ?? styles.genHtml} dangerouslySetInnerHTML={{ __html: contentHtml }} />
}
